import axios from 'axios';

// Normaliza BASE para evitar duplo "/api" quando a env já inclui "/api"
const RAW_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
const API_BASE_URL = RAW_BASE_URL
  .replace(/\/+$/, '')       // remove barra no fim
  .replace(/\/api$/, '');    // remove "/api" se vier na env

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Interceptor para logging de erros
api.interceptors.response.use(
    response => response,
    error => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

// Exponha a base para inspeção no console
if (typeof window !== 'undefined') {
  try {
    window.__API_BASE__ = API_BASE_URL;
    console.log('[API] Base URL configurada:', API_BASE_URL);
  } catch (_) {}
}

// Log de requisições
if (api && api.interceptors && api.interceptors.request) {
  api.interceptors.request.use((config) => {
    const fullUrl = `${config.baseURL || ''}${config.url || ''}`;
    console.log('[API Request]', (config.method || 'GET').toUpperCase(), fullUrl, { data: config.data });
    return config;
  }, (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  });
}

// Mantenha o interceptor de resposta existente, mas acrescente logs mínimos
if (api && api.interceptors && api.interceptors.response) {
  api.interceptors.response.use(
    (response) => {
      const fullUrl = `${response.config?.baseURL || ''}${response.config?.url || ''}`;
      console.log('[API Response]', response.status, fullUrl, response.data);
      return response;
    },
    (error) => {
      const status = error?.response?.status;
      const fullUrl = `${error?.config?.baseURL || ''}${error?.config?.url || ''}`;
      console.error('[API Response Error]', status, fullUrl, error?.response?.data || error.message);
      return Promise.reject(error);
    }
  );
}

// Adicione log específico em generateTitles
export const postsAPI = {
    // existentes
    list: (page = 1, limit = 10) => api.get(`/api/posts?page=${page}&limit=${limit}`),
    getById: (id) => api.get(`/api/posts/${id}`),
    create: (postData) => api.post('/api/posts', postData),
    generateArticle: (payload) => api.post('/api/posts/generate', payload),
    generateTitles: (topic) => {
        console.log('[postsAPI.generateTitles] base=', API_BASE_URL, 'url=/api/posts/generate-titles', 'topic=', topic);
        return api.post('/api/posts/generate-titles', { topic });
    },
    saveGenerated: (payload) => api.post('/api/posts/save-generated', payload),
    sendPublishToWordPress: (id, payload) => api.post(`/api/posts/${id}/wordpress/publish`, payload),
    sendDraftToWordPress: (id, payload) => api.post(`/api/posts/${id}/wordpress/draft`, payload),

    // compatibilidade com chamadas existentes em componentes
    getAllPosts: (params = {}) => api.get('/api/posts', { params }),
    getPostById: (id) => api.get(`/api/posts/${id}`),
    createPost: (postData) => api.post('/api/posts', postData),
    updatePost: (id, postData) => api.put(`/api/posts/${id}`, postData),
    deletePost: (id) => api.delete(`/api/posts/${id}`),
    getDashboardStats: () => api.get('/api/posts/stats'),
    publishToWordPress: (id, payload) => api.post(`/api/posts/${id}/wordpress/publish`, payload),
    refineText: (textData) => api.post('/api/refine', textData)
};

export const categoriesAPI = {
    getAllCategories: () => api.get('/api/categories'),
    createCategory: (categoryData) => api.post('/api/categories', categoryData)
};

export const promptsAPI = {
    list: () => api.get('/api/prompts'),
    get: (id) => api.get(`/api/prompts/${id}`),
    create: (data) => api.post('/api/prompts', data),
    update: (id, data) => api.put(`/api/prompts/${id}`, data),
    remove: (id) => api.delete(`/api/prompts/${id}`)
};

export const referencesAPI = {
    list: () => api.get('/api/references'),
    createUrl: (data) => api.post('/api/references/url', data),
    uploadFile: (formData) => api.post('/api/references/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.put(`/api/references/${id}`, data),
    remove: (id) => api.delete(`/api/references/${id}`),
    getFileUrl: (name) => `${API_BASE_URL}/api/references/file/${name}`
};

export const errorLogsAPI = {
  list: (limit = 50) => api.get(`/api/error-logs?limit=${limit}`)
};

export const suggestionsAPI = {
  getAll: () => api.get('/api/suggestions')
};

export default api;